import * as React from 'react';
import { classNames, validatePropType } from '@egds/react-core/utils';
import styles from '../../../../../styles/egds-app-growth-animated-icon.css';
import { downloadIcon } from '../icons/download-icon/index.esm.js';
import { openInNewIcon } from '../icons/open-in-new-icon/index.esm.js';
import { downloadIconAnimated } from '../icons/download-icon-animated/index.esm.js';
import { openInNewIconAnimated } from '../icons/open-in-new-icon-animated/index.esm.js';

const getClassNameList = classNames.bind(styles);
var AnimatedIconSize;
(function (AnimatedIconSize) {
    AnimatedIconSize["EXTRA_SMALL"] = "xsmall";
    AnimatedIconSize["SMALL"] = "small";
    AnimatedIconSize["MEDIUM"] = "medium";
    AnimatedIconSize["LARGE"] = "large";
    AnimatedIconSize["XLARGE"] = "xlarge";
})(AnimatedIconSize || (AnimatedIconSize = {}));
const getIconByName = (name) => {
    switch (name) {
        case 'download':
            return downloadIcon;
        case 'open_in_new':
            return openInNewIcon;
        case 'download_animated':
            return downloadIconAnimated;
        case 'open_in_new_animated':
            return openInNewIconAnimated;
        default:
            return 'download';
    }
};
const AnimatedIcon = (props) => {
    const baseCssClass = 'animated-icon';
    const { name, className, description, size = AnimatedIconSize.MEDIUM, title } = props;
    const domRef = (b) => {
    };
    const wrapperClassNames = getClassNameList(baseCssClass, className, {
        [`${baseCssClass}-${size}`]: validatePropType(size, AnimatedIconSize) && size !== AnimatedIconSize.MEDIUM,
    });
    const a11yProps = {
        'aria-describedby': description ? `$-description` : undefined,
        'aria-hidden': title || description ? undefined : true,
        'aria-label': title || undefined,
        role: title || description ? 'img' : undefined,
    };
    const iconProps = {
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
        xmlnsXlink: 'http://www.w3.org/1999/xlink',
    };
    const svgProps = {
        ref: domRef,
        className: wrapperClassNames,
        ...a11yProps,
        ...iconProps,
    };
    const innerNodes = (html) => {
        if (html.length > 0) {
            return {
                dangerouslySetInnerHTML: {
                    __html: html,
                },
            };
        }
        return {};
    };
    const innerNodesMarkup = getIconByName(name);
    return React.createElement("svg", { ...svgProps, ...innerNodes(innerNodesMarkup) });
};
AnimatedIcon.displayName = 'AnimatedIcon';

export { AnimatedIcon, AnimatedIconSize };
//# sourceMappingURL=index.esm.js.map
